import {useEffect, useRef, useState} from "react";
import navBgCharacterActive from "../../assets/images/home/nav_bg_character_active.png";
import navBgCharacterActive2x from "../../assets/images/home/nav_bg_character_active@2x.png";
import navBgFeatureActive from "../../assets/images/home/nav_bg_feature_active.png";
import navBgFeatureActive2x from "../../assets/images/home/nav_bg_feature_active@2x.png";
import navBgHomeActive from "../../assets/images/home/nav_bg_home_active.png";
import navBgHomeActive2x from "../../assets/images/home/nav_bg_home_active@2x.png";
import navBgNewsActive from "../../assets/images/home/nav_bg_news_active.png";
import navBgNewsActive2x from "../../assets/images/home/nav_bg_news_active@2x.png";
import navBtnAudioOff from "../../assets/images/home/nav_btn_audio_off.svg";
import navBtnAudioOn from "../../assets/images/home/nav_btn_audio_on.svg";
import navBtnPreregister from "../../assets/images/commonbtn/nav_btn_preregister.png";
import navBtnPreregister2x from "../../assets/images/commonbtn/nav_btn_preregister@2x.png";
import navBtnUser from "../../assets/images/home/nav_btn_user.svg";
import navLine from "../../assets/images/home/nav_line.png";
import navLinkBili from "../../assets/images/home/nav_link_bili.svg";
import navLinkDy from "../../assets/images/home/nav_link_dy.svg";
import navLinkTap from "../../assets/images/home/nav_link_tap.svg";
import navLinkUnion from "../../assets/images/home/nav_link_union.svg";
import navLinkWb from "../../assets/images/home/nav_link_wb.svg";
import navLinkXhs from "../../assets/images/home/nav_link_xhs.svg";
import navLogo from "../../assets/images/home/nav_logo.png";
import navLogo2x from "../../assets/images/home/nav_logo@2x.png";

export const homeNavItems = [
    {id: "home", label: "首页", href: "#home", activeBg: navBgHomeActive, activeBg2x: navBgHomeActive2x, activeWidth: 118, activeHeight: 50, gapAfter: 30},
    {id: "char", label: "角色介绍", href: "#char", activeBg: navBgCharacterActive, activeBg2x: navBgCharacterActive2x, activeWidth: 127, activeHeight: 51, gapAfter: 22},
    {id: "feature", label: "特色玩法", href: "#feature", activeBg: navBgFeatureActive, activeBg2x: navBgFeatureActive2x, activeWidth: 118, activeHeight: 49, gapAfter: 34},
    {id: "news", label: "新闻公告", href: "#news", activeBg: navBgNewsActive, activeBg2x: navBgNewsActive2x, activeWidth: 111, activeHeight: 51, gapAfter: 0}
];

const SOCIAL_LINK_XHS_URL = "https://xhslink.cn/m/13nXyy3KB16";
const SOCIAL_LINK_WB_URL = "https://weibo.com/u/7965573423";
const SOCIAL_LINK_BILI_URL = "https://b23.tv/Eqh08pJ";
const SOCIAL_LINK_DY_URL = "https://v.douyin.com/4T_ACjPELgo/ 2@9.com";
export const SOCIAL_LINK_TAP_URL = "https://www.taptap.cn/user/755350585";

export const homeSocialLinks = [
    {id: "xhs", label: "小红书", href: SOCIAL_LINK_XHS_URL, icon: navLinkXhs, iconWidth: 20, iconHeight: 20},
    {id: "wb", label: "微博", href: SOCIAL_LINK_WB_URL, icon: navLinkWb, iconWidth: 22, iconHeight: 18},
  //  {id: "bili", label: "哔哩哔哩", href: SOCIAL_LINK_BILI_URL, icon: navLinkBili, iconWidth: 20, iconHeight: 19},
    {id: "dy", label: "抖音", href: SOCIAL_LINK_DY_URL, icon: navLinkDy, iconWidth: 15, iconHeight: 18},
    {id: "tap", label: "TapTap", href: SOCIAL_LINK_TAP_URL, icon: navLinkTap, iconWidth: 20, iconHeight: 20}
];

export default function HomeTopbar({
    activeNavId,
    onNavClick,
    isMusicOn,
    onMusicToggle,
    onReserveClick,
    reserveHref,
    reserveClassName,
    logoHref,
    isUserMenuOpen,
    userPhone,
    onUserClick,
    onUserLogout
}) {
    const currentActiveNavId = activeNavId || "home";
    const [isSocialMenuOpen, setIsSocialMenuOpen] = useState(false);
    const socialWrapRef = useRef(null);
    const reserveButtonClassName = reserveClassName ? `home-nav-reserve-btn ${reserveClassName}` : "home-nav-reserve-btn";
    const shouldRenderReserveButton = typeof onReserveClick === "function";
    const maskedPhone = userPhone ? userPhone.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2") : "";

    useEffect(() => {
        setIsSocialMenuOpen(false);
    }, [currentActiveNavId]);

    useEffect(() => {
        if (!isSocialMenuOpen) return undefined;

        const handlePointerDown = function (event) {
            if (socialWrapRef.current && !socialWrapRef.current.contains(event.target)) {
                setIsSocialMenuOpen(false);
            }
        };
        const handleKeyDown = function (event) {
            if (event.key === "Escape") setIsSocialMenuOpen(false);
        };

        document.addEventListener("pointerdown", handlePointerDown);
        window.addEventListener("keydown", handleKeyDown);

        return () => {
            document.removeEventListener("pointerdown", handlePointerDown);
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [isSocialMenuOpen]);

    const handleNavClick = function (event, href) {
        if (typeof onNavClick === "function") {
            onNavClick(event, href);
        }
    };

    const reserveContent = (
        <picture className="home-nav-reserve-picture">
            <source media="(min-width: 1921px)" srcSet={navBtnPreregister2x}/>
            <img src={navBtnPreregister} alt="" aria-hidden="true"/>
        </picture>
    );

    return (
        <div className="home-topbar" aria-label="顶部导航">
            <div className="home-topbar-bg" aria-hidden="true"></div>
            <div className="home-topbar-inner">
                <a className="home-nav-logo" href={logoHref || "#home"} onClick={(event) => handleNavClick(event, "#home")}>
                    <picture className="home-nav-logo-picture">
                        <source media="(min-width: 1921px)" srcSet={navLogo2x}/>
                        <img src={navLogo} alt="失乐枷锁"/>
                    </picture>
                </a>
                <nav className="home-nav" aria-label="主导航">
                    <ul className="home-nav-list" id="topNav">
                        {homeNavItems.map((item) => (
                            <li
                                key={item.id}
                                className={currentActiveNavId === item.id ? "active" : ""}
                                style={{
                                    "--active-nav-bg": `url(${item.activeBg})`,
                                    "--active-nav-bg-2x": `url(${item.activeBg2x})`,
                                    "--active-nav-width": `${item.activeWidth}px`,
                                    "--active-nav-height": `${item.activeHeight}px`,
                                    "--nav-gap-after": `${item.gapAfter}px`
                                }}
                            >
                                <a
                                    href={item.href}
                                    onClick={(event) => handleNavClick(event, item.href)}
                                >
                                    <span>{item.label}</span>
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>
                <div className="home-topbar-actions">
                    <div className="home-social-wrap" ref={socialWrapRef}>
                        <button
                            className="home-social-menu-btn"
                            type="button"
                            aria-label="社交媒体"
                            aria-expanded={isSocialMenuOpen}
                            onClick={() => setIsSocialMenuOpen((isOpen) => !isOpen)}
                        >
                            <img src={navLinkUnion} alt="" aria-hidden="true"/>
                        </button>
                        <div className={isSocialMenuOpen ? "home-social-list open" : "home-social-list"} aria-label="社交媒体">
                            {homeSocialLinks.map((item) => (
                                <a
                                    className={`home-social-link home-social-${item.id}`}
                                    key={item.id}
                                    href={item.href}
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label={item.label}
                                    style={{
                                        "--social-icon-width": `${item.iconWidth}px`,
                                        "--social-icon-height": `${item.iconHeight}px`
                                    }}
                                >
                                    <img src={item.icon} alt="" aria-hidden="true"/>
                                </a>
                            ))}
                        </div>
                    </div>
                    <img className="home-nav-line" src={navLine} alt="" aria-hidden="true"/>
                    <button className={isMusicOn === false ? "home-music-btn" : "home-music-btn on"} type="button" aria-label="音乐开关" onClick={onMusicToggle}>
                        <img src={isMusicOn === false ? navBtnAudioOff : navBtnAudioOn} alt="" aria-hidden="true"/>
                    </button>
                    <div className="home-user-wrap">
                        <button className="home-user-btn" type="button" aria-label="用户中心" onClick={onUserClick}>
                            <img src={navBtnUser} alt="" aria-hidden="true"/>
                        </button>
                        {isUserMenuOpen && maskedPhone ? (
                            <div className="home-user-popover" role="menu">
                                <span>{maskedPhone}</span>
                                <button type="button" onClick={onUserLogout}>[登出]</button>
                            </div>
                        ) : null}
                    </div>
                    {shouldRenderReserveButton ? (
                        <button className={reserveButtonClassName} type="button" onClick={onReserveClick}>
                            {reserveContent}
                        </button>
                    ) : (
                        <a className={reserveButtonClassName} href={reserveHref || "#home"}>
                            {reserveContent}
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
}
